import clsx from "clsx";
import { CommentIcon } from "@/shared/assets/svg/icons";
import "./comment-chip.scss";

export function CommentChip({
  className,
  text = "Комментарий",
}: {
  className?: string;
  text?: string;
}) {
  return (
    <div className={clsx("comment-chip", className ?? "").trim()}>
      <div className="comment-chip__text">{text}</div>
      <div className="comment-chip__icon">
        <div className="comment-chip__icon-box">
          <CommentIcon />
        </div>
      </div>
    </div>
  );
}


